module.exports = __webpack_public_path__ + "img/banner16.1a26efdb.png";